import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MailX, Undo2 } from "lucide-react";
import { api, errorMessage } from "../lib/api";
import { Button } from "../components/ui/button";

export default function EventOptOutPage() {
  const { token } = useParams();
  const [state, setState] = useState<{ email: string; name: string; opted_out: boolean } | null>(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/private-events/invite/${token}/optout`).then((r) => setState(r.data)).catch((e) => setError(errorMessage(e)));
  useEffect(() => { if (token === "preview") setState({ email: "you@example.com", name: "Preview", opted_out: false }); else load(); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps
  const act = async (undo: boolean) => {
    if (token === "preview") { setState((s) => s && { ...s, opted_out: !undo }); return; }
    setBusy(true);
    try { const r = await api.post(`/private-events/invite/${token}/optout`, null, { params: { undo } }); setState((s) => s && { ...s, opted_out: r.data.opted_out }); } catch (e) { setError(errorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <main className="min-h-screen bg-[var(--paper)] px-4 py-16" data-testid="event-optout-page">
      <div className="mx-auto max-w-lg border border-border bg-white/70 p-8 text-center">
        <img src="/brand/logo.png" alt="Pierre Hourlier Wines" className="mx-auto mb-6 w-36" />
        {error && <p className="text-sm text-[var(--wine)]" data-testid="event-optout-error">{error}</p>}
        {state && !state.opted_out && (
          <>
            <MailX className="mx-auto h-8 w-8 text-[var(--wine)]" strokeWidth={1.5} />
            <h1 className="mt-3 font-serif text-2xl">No more tasting invitations?</h1>
            <p className="mt-2 text-sm text-neutral-600">We'll stop sending private tasting invitations to <strong data-testid="event-optout-email">{state.email}</strong>. Order confirmations and anything about your account carry on as normal.</p>
            <Button className="mt-6 rounded-none" disabled={busy} onClick={() => act(false)} data-testid="event-optout-confirm">{busy ? "One moment…" : "Yes, stop tasting invitations"}</Button>
          </>
        )}
        {state && state.opted_out && (
          <>
            <h1 className="font-serif text-2xl">Done — no more tasting invitations</h1>
            <p className="mt-2 text-sm text-neutral-600" data-testid="event-optout-done">{state.email} won't be added to future guest lists. Changed your mind?</p>
            <Button variant="outline" className="mt-6 rounded-none" disabled={busy} onClick={() => act(true)} data-testid="event-optout-undo"><Undo2 className="mr-1 h-4 w-4" /> Keep inviting me</Button>
          </>
        )}
        <p className="mt-8 text-xs text-neutral-500">Pierre Hourlier Wines · Unit 11, Melbourne Hall Visitor Centre, Melbourne DE73 8EN · 01332 341466</p>
      </div>
    </main>
  );
}
